import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_ws/w/$workspaceId/credits/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/w/$workspaceId/credits/overview',
      params: { workspaceId: params.workspaceId },
    })
  },
})
